import { SET_APP_THUMB } from "../actions/const";

const initialState = {
	resetState: false,
	showModal: false,
	isLoadingAction: false,

	selectedData: null,
	formType: "",
	formTitle: "",
	formId: "",

	title: "",
	browser: {
		label: "INTERNAL",
		value: "INTERNAL",
	},
	url: "",
	image: null,
	imageBg: null,
	startDate: "",
	endDate: "",
	sort: 0,

	browserOptions: [
		{
			label: "INTERNAL",
			value: "INTERNAL",
		},
		{
			label: "EXTERNAL",
			value: "EXTERNAL",
		},
	],
};

function reducer(state = initialState, action) {
	let { type, payload } = action;

	switch (type) {
		case SET_APP_THUMB:
			if (
				typeof action.payload.resetState !== "undefined" &&
				action.payload.resetState
			) {
				action.payload = { ...initialState };
			}
			return Object.assign({}, state, action.payload);
		default: {
			return state;
		}
	}
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/AppThumb.js